import React from "react";

import {
  components,
  DropdownIndicatorProps,
  GroupBase,
  OptionProps,
  SingleValueProps
} from "react-select";

import { CustomDropdownProps } from "./types";

// Created for while we're using localizeJS to manage our translations
// can probably be removed once we have our own management system in place
export function customOption<
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
>(dataNoTranslate?: boolean) {
  return (props: OptionProps<Option, IsMulti, Group>) => {
    const { children, ...otherProps } = props;

    return (
      <components.Option {...otherProps}>
        {dataNoTranslate ? <span data-notranslate>{children}</span> : children}
      </components.Option>
    );
  };
}

export function customSingleValue<
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
>({
  injectedChildren,
  dataNoTranslate
}: {
  injectedChildren?: (children: React.ReactNode) => React.ReactNode;
  dataNoTranslate?: boolean;
}) {
  return (props: SingleValueProps<Option, IsMulti, Group>) => {
    const children = () =>
      dataNoTranslate ? (
        <span data-notranslate>{props.children}</span>
      ) : (
        props.children
      );

    return (
      <components.SingleValue {...props}>
        {!!injectedChildren ? injectedChildren(children()) : children()}
      </components.SingleValue>
    );
  };
}

export function customDropdownIndicator<
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
>(children?: React.ReactNode) {
  return (props: DropdownIndicatorProps<Option, IsMulti, Group>) => (
    <components.DropdownIndicator {...props}>
      {children}
    </components.DropdownIndicator>
  );
}

export function buildCustomDropdownComponents<
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
>({
  dataNoTranslate,
  children
}: Pick<CustomDropdownProps, "children" | "dataNoTranslate">) {
  return {
    SingleValue: customSingleValue<Option, IsMulti, Group>({
      injectedChildren: children?.singleValue,
      dataNoTranslate
    }),
    Option: customOption<Option, IsMulti, Group>(dataNoTranslate),
    DropdownIndicator: customDropdownIndicator<Option, IsMulti, Group>(
      children?.indicator
    )
  };
}
